export default "__VITE_ASSET__e9b68812__"